module.exports = {
  title: {
    nav: [{
        title: '首页',
        path: '/homezh'
      },
      {
        title: '公司介绍',
        path: '/profilezh'
      },
      {
        title: '产品中心',
        path: '/productzh'
      },
      {
        title: '设备及技术解决方案',
        path: '/devicezh'
      },
      {
        title: '投资并购',
        path: '/investzh'
      },
      {
        title: '人才招聘',
        path: '/recruitzh'
      },
      {
        title: '客户留言',
        path: '/bbszh'
      },
      {
        title: '联系我们',
        path: '/contactzh'
      }
    ]
  },
  images: {
    a00index1_02: require('../img/zh/00index1_02.jpg'),
    a00index1_03: require('../img/zh/00index1_03.jpg'),
    a1_02: require('../img/zh/1_02.jpg'),
    ff_06: require('../img/zh/ff_06.jpg')
  },
  text: {
    top1: '·设为首页',
    top2: '·加入收藏',
	search: '搜索',
    bott1: 'coryright@2011 北京马可泰克国际科技发展有限公司 all rights reserved 京ICP备05044301号'
  }

}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js